// This file is auto-generated by @hey-api/openapi-ts

export const ElectronicWalletOperationsEnum = {
    RECHARGE: 'RECHARGE',
    WITHDRAW: 'WITHDRAW',
    PAYMENT: 'PAYMENT',
    TRANSFER: 'TRANSFER',
    PAK_TRANSFER: 'PAK_TRANSFER'
} as const;

export type ElectronicWalletOperationsEnum = typeof ElectronicWalletOperationsEnum[keyof typeof ElectronicWalletOperationsEnum];
